// @ts-nocheck
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    markSkipOnCompleteIfOnErrorIsSet,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import {
    CreateAccountApiParameter,
    createAccountRequest as addAccountApi,
} from "@store/Framework/Services/AccountRequestService";
import { CreateAccountModel } from "@store/Framework/Types/ApiModels";

export interface CreateAccountParameter {
    userName: string;
    email: string;
    password: string;
    isSubscribed: boolean;
    firstName: string;
    lastName: string;
    customerType: string;
    phone: string;
    company: string;
    typeOfBusiness: string;
    emailRecipient: string;
    onSuccess?: (results: any) => void;
    onError?: (error: string) => void;
}

type HandlerType = ApiHandlerDiscreteParameter<
    CreateAccountParameter,
    CreateAccountApiParameter,
    ServiceResult<CreateAccountModel>
>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        account: {
            ...props.parameter,
        } as CreateAccountModel,
    };
};

export const CreateAccountRequest: HandlerType = async props => {
    props.apiResult = await addAccountApi(props.apiParameter);
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        markSkipOnCompleteIfOnErrorIsSet(props);
        props.parameter.onError?.(props.apiResult.errorMessage!);
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess?.(props.apiResult.result);
    }
};

export const chain = [PopulateApiParameter, CreateAccountRequest, ExecuteOnErrorCallback, ExecuteOnSuccessCallback];

const createAccountRequest = createHandlerChainRunner(chain, "CreateAccountRequest");
export default createAccountRequest;
